import React, {Fragment, useState, useEffect} from 'react';
import Grid from "@material-ui/core/Grid";
import SimpleReactValidator from "simple-react-validator";
import {toast} from "react-toastify";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {Link, withRouter} from "react-router-dom";
import NewNavbar from '../../new-components/NewNavbar'
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from '../../new-components/NewOverrides'
import NewDesignSystem from '../../new-components/NewDesignSystem'
import NewFooter from '../../new-components/NewFooter'
import NewMadeWith from '../../new-components/NewMadeWith'
import NewScrollTop from '../../new-components/NewScrollTop'

import './style.scss';

const ForgotPassword = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [value, setValue] = useState({
        email: '',
    });

    const changeHandler = (e) => {
        setValue({...value, [e.target.name]: e.target.value});
        validator.showMessages();
    };

    const [validator] = React.useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));

    const submitForm = (e) => {
        e.preventDefault();
        if (validator.allValid()) {
            setValue({
                email: '',
            });
            validator.hideMessages();
            toast.success('You successfully Login!');
            props.history.push('/login');
        } else {
            validator.showMessages();
            toast.error('Empty field is not allowed!');
        }
    };
    return (
        <Fragment>
            <NewNavbar/>
            <NewOverrides/>
            <NewDesignSystem/>

      <NewPageHeader />
            <Grid className="loginWrapper">

                <Grid className="loginForm">
                    <h2>Forgot Password</h2>
                    <p>Reset your account password</p>
                    <form onSubmit={submitForm}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <TextField
                                    className="inputOutline"
                                    fullWidth
                                    placeholder="E-mail"
                                    value={value.email}
                                    variant="outlined"
                                    name="email"
                                    label="E-mail"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onBlur={(e) => changeHandler(e)}
                                    onChange={(e) => changeHandler(e)}
                                />
                                {validator.message('email', value.email, 'required|email')}
                            </Grid>
                            <Grid item xs={12}>
                                <Grid className="formFooter">
                                    <Button fullWidth className="cBtn cBtnLarge cBtnTheme" type="submit">Resend
                                        Password</Button>
                                </Grid>
                                <Grid className="loginWithSocial">
                                    <Button className="facebook"><i className="fa fa-facebook"></i></Button>
                                    <Button className="twitter"><i className="fa fa-twitter"></i></Button>
                                    <Button className="linkedin"><i className="fa fa-linkedin"></i></Button>
                                </Grid>
                                <p className="noteHelp">Already have an account? <Link to="/login">Return to Sign In</Link>
                                </p>
                            </Grid>
                        </Grid>
                    </form>
                    <div className="shape-img">
                        <i className="fi flaticon-honeycomb"></i>
                    </div>
                </Grid>
            </Grid>
            <NewFooter/>
            <NewMadeWith/>
            <NewScrollTop/>
        </Fragment>
    )
};

export default withRouter(ForgotPassword);